import { DisplayWithIcon } from "../shared/Typography/types";
import { GetTypographyContent } from "../shared/Typography/Typography";
import {
  TestResultIconAndTypography,
  TestResultsIcon,
} from "./TestResults.styles";

export const TestResultsCarrierInfo = (
  displayWithIcon: DisplayWithIcon,
  label = "Carrier Screen",
): React.ReactElement => (
  <>
    {GetTypographyContent({
      content: label,
      size: "large",
      textColor: "greyMedium",
      isBold: true,
      isCaps: true,
    })}
    <div>
      <TestResultIconAndTypography>
        <TestResultsIcon
          marginLeft={
            (displayWithIcon.rawDisplay || displayWithIcon.display) ===
            "See Report"
          }
        >
          {displayWithIcon.icon}
        </TestResultsIcon>
        {GetTypographyContent({
          content: displayWithIcon.display,
          size: "medium",
          textColor: "greyMedium",
        })}
      </TestResultIconAndTypography>
    </div>
  </>
);
